export default "__VITE_ASSET__Byk7tjzL__"